import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { RootState } from '../store'
import moment from 'moment'
import { IModalBase } from '@interfaces/commonInterfaces'

export interface IState {
  productList?: any
  productOptionList?: any
  productDetail?: any
  reloadProductList?: string | null
  modalProduct?: IModalBase
}

const initialState: IState = {
  productList: [],
  productOptionList: [],
  productDetail: {},
  reloadProductList: null,
  modalProduct: {
    visible: false,
    record: {}
  }
}

export const productDucks = createSlice({
  name: 'product',
  initialState,
  reducers: {

    getListProduct: (state: RootState, action: PayloadAction<any>) => {
      state.productList = { loading: true, queryStr: action.payload }
    },
    getListProductSuccess: (state, action: PayloadAction<any>) => {
      state.productList = { loading: false, ...action.payload }
    },
    getListProductFail: (state, action: PayloadAction<any>) => {
      state.productList = { loading: false, ...action.payload }
    },

    getListOptionProduct: (state: RootState, action: PayloadAction<any>) => {
      state.productOptionList = { loading: true, queryStr: action.payload }
    },
    getListOptionProductSuccess: (state, action: PayloadAction<any>) => {
      state.productOptionList = { loading: false, ...action.payload }
    },
    getListOptionProductFail: (state, action: PayloadAction<any>) => {
      state.productOptionList = { loading: false, ...action.payload }
    },

    getDetailProduct: (state: RootState, action: PayloadAction<any>) => {
      state.productDetail = { loading: true, id: action.payload }
    },
    getDetailProductSuccess: (state, action: PayloadAction<any>) => {
      state.productDetail = { loading: false, ...action.payload }
    },
    getDetailProductFail: (state, action: PayloadAction<any>) => {
      state.productDetail = { loading: false, ...action.payload }
    },

    setReloadProductList: (state: RootState) => {
      state.reloadProductList = String(moment())
    },
    setModalProduct: (state, action: PayloadAction<IModalBase>) => {
      state.modalProduct = action.payload
    },

  },
})

// Action creators are generated for each case reducer function
export const {
  getListProduct,
  getListProductSuccess,
  getListProductFail,

  getListOptionProduct,
  getListOptionProductSuccess,
  getListOptionProductFail,

  getDetailProduct,
  getDetailProductSuccess,
  getDetailProductFail,

  setReloadProductList,
  setModalProduct
} = productDucks.actions

export default productDucks.reducer
